import { industries } from '../data/mock';

export default function Industries() {
  return (
    <section
      id="industries"
      className="relative px-5 md:px-10 lg:px-14 py-24 md:py-32 border-t border-white/10"
      data-testid="industries-section"
    >
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
        <div className="max-w-2xl">
          <p className="text-[10px] md:text-[11px] tracking-[0.3em] text-[#FF3D2E] mb-6">
            — INDUSTRIES SERVED
          </p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-white">
            Built for brands that move culture forward.
          </h2>
        </div>
        <p className="md:max-w-md text-white/70 text-base leading-relaxed">
          SMG works across the categories where identity, culture, and commerce collide — from athlete-driven programs to premium hospitality, spirits, travel, and health & wellness.
        </p>
      </div>

      <ul className="flex flex-wrap gap-2 md:gap-3">
        {industries.map((label, i) => (
          <li
            key={label}
            className="group relative border border-white/15 hover:border-white/60 hover:bg-white/5 px-4 md:px-5 py-3 transition-colors"
            data-testid={`industry-${i}`}
          >
            <div className="flex items-center gap-3">
              <span className="text-[9px] tracking-[0.3em] text-white/40 group-hover:text-[#FF3D2E] transition-colors">
                {String(i + 1).padStart(2, '0')}
              </span>
              <span className="text-white text-sm md:text-base tracking-tight">{label}</span>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
